/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { CustomField } from "api/route-data/story-route-data";
import { get, has, isEmpty } from "lodash";

export function getTemplateCustomMetadata(customMetadataFields: CustomField[], storyTemplate: string): CustomField[] {
  if (isEmpty(customMetadataFields) || !storyTemplate) return [];

  return customMetadataFields.filter(({ config }: CustomField) => {
    const enabledForAllTemplates =
      !has(config, "enabled-for-all-templates") || get(config, "enabled-for-all-templates");
    const contentTemplates = get(config, "content-templates", []) as string[];
    return enabledForAllTemplates || contentTemplates.includes(storyTemplate);
  });
}
